let userInfo
if (location.host.indexOf('hengchiauto.com') > -1) {
  // 开发环境、测试环境、线上环境
  userInfo = {}
} else {
  userInfo = {
    userName: 'xx', // 用户名称
    nickName: 'xx', // 用户昵称
    phone: '18101719693', // 手机号
    unionId: '', // 用户编号
    avatar: '', // 用户头像
    email: '', // 用户邮箱
    isInWhiteList: '0', // 是否在白名单内
    acpToken: 'f06af35b3409d710f4001c5f474ad233', // 汽车用户中心token
    deviceBrand: 'Xiaomi',
    deviceModel: 'MI 8',
    deviceOs: 'Android',
    deviceOsVersion: '10',
    deviceId: 'xxxxxx',
  }
}
export default {
  getUserInfo: userInfo,
  login: userInfo,
  confirmLogin: userInfo,
}
